<template>
  <label class="checkbox" :class="classes">
    <input
      type="checkbox"
      :checked.prop="isChecked"
      name="name"
      @click="onClick"
    />

    <div class="checkbox__checkmark"></div>

    <span class="checkbox__name">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: "CCheckbox",
  props: {
    label: String,
    value: {
      required: true
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    }
  },

  data() {
    return {
      isChecked: this.value
    };
  },

  computed: {
    classes() {
      return [{ "is-checked": this.isChecked }];
    }
  },

  watch: {
    value() {
      this.isChecked = this.value;
    }
  },

  methods: {
    onClick(e) {
      this.isChecked = e.target.checked;
      this.$emit("input", e.target.checked ? this.trueValue : this.falseValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.checkbox {
  display: flex;
  align-items: center;

  @media #{$mobile} {
    height: 54px;
    padding: 0 15px;
  }

  & input {
    display: none;
  }

  &__checkmark {
    width: 30px;
    height: 30px;
    margin-right: 20px;

    border: 1px solid #cccccc;
    border-radius: 4px;
  }

  &__name {
    max-width: 230px;
  }

  &.is-checked {
    /*background-color: #f4f4f4;*/
  }

  &.is-checked &__checkmark {
    background: #3a5eec url("../../assets/img/checkmark.svg");
    background-position: center;
    background-repeat: no-repeat;

    border-radius: 4px;
  }
}
</style>
